module.exports = __webpack_public_path__ + "img/NP7.3a00dd23.jpeg";